import { DialogBoundary, DialogTrigger } from "@suse-o11y/dialog";
import React, { type FC } from "react";

import { Button } from "~/components/button";

import { ErrorDetailsDrawer } from "../../_drawer/_error-details-drawer";
import { DataError } from "../data-error/DataError";

export interface ErrorScreenProps {
	error: unknown;
	handleError?: () => void;
	noShadow?: boolean;
}

export const ErrorScreen: FC<React.PropsWithChildren<ErrorScreenProps>> = ({
	handleError,
	error,
	noShadow,
	children,
}) => (
	<DataError
		button={
			handleError ? (
				<Button
					className="uppercase"
					data-testid="error-events-screen-retry-button"
					onClick={handleError}
					variant="primary"
				>
					Try Again
				</Button>
			) : undefined
		}
		data-testid="error-events-screen"
		header="Something went wrong"
		noShadow={noShadow}
	>
		Unfortunately, it looks like{" "}
		<DialogBoundary>
			<DialogTrigger className="link link-secondary">something</DialogTrigger>
			<ErrorDetailsDrawer error={error} />
		</DialogBoundary>{" "}
		went wrong.
		{children}
	</DataError>
);
